import {useContext} from 'react';

import MainSidebarContext from '../../contexts/MainSidebarContext';

const useMainSidebar = () => {
  return useContext(MainSidebarContext);
};

export default useMainSidebar;
